import { useState, useEffect } from 'react';

export const useBranding = () => {
  const [showBranding, setShowBranding] = useState(false);

  useEffect(() => {
    const hostname = window.location.hostname;
    setShowBranding(hostname.includes('lianduang'));
  }, []);

  return showBranding;
};